import {
  Button,
  CircularProgress,
  Fab,
  IconButton,
  Tooltip,
  makeStyles,
} from '@material-ui/core'
import { mdiCreation, mdiRobotOutline } from '@mdi/js'
import Icon from '@mdi/react'
import axios from 'axios'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import colors from '../../assets/colors'
import config from '../../config'
import { SNACKBAR } from '../main/MainActions'

const useStyles = makeStyles(theme => ({
  wrapper: {
    position: 'fixed',
    right: '24px',
    bottom: '24px',
    zIndex: theme.zIndex.drawer + 2,
  },
  fab: {
    backgroundColor: colors.primary,
    color: '#FFF',
    '&:hover': {
      backgroundColor: colors.primary,
      opacity: 0.85,
    },
  },
  iconButton: {
    color: colors.primary,
  },
  '@keyframes liquidFlow': {
    '0%': { backgroundPosition: '0% 50%' },
    '50%': { backgroundPosition: '100% 50%' },
    '100%': { backgroundPosition: '0% 50%' },
  },
  headerButton: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '13px',
    color: '#FFF',
    height: '32px',
    padding: '0 12px',
    marginLeft: '4px',
    borderRadius: '8px',
    backgroundSize: '250% 250%',
    background: `linear-gradient(120deg, #0f0c29 0%, #23246b 30%, ${colors.secondary} 60%, #23246b 80%, #0f0c29 100%)`,
    animation: '$liquidFlow 6s ease infinite',
    '&:disabled': {
      color: '#FFF',
      opacity: 0.6,
      animationPlayState: 'paused',
    },
  },
  headerIcon: {
    color: '#FFF',
  },
  progress: {
    color: colors.primary,
  },
  progressHeader: {
    color: '#FFF',
  },
}))

const ERRO_PADRAO = 'Não foi possível abrir o assistente agora.'

const AssistenteIaFab = ({ variant = 'fab' }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const user = useSelector(state => state.auth.user)
  const activeAiAssistant = useSelector(state => state.auth.activeAiAssistant)
  const [abrindo, setAbrindo] = useState(false)

  if (!activeAiAssistant || user?.has_laundry_client === false) {
    return null
  }

  const falhar = mensagem => {
    dispatch({
      type: SNACKBAR.HARDFAIL,
      error: { message: mensagem || ERRO_PADRAO },
    })
  }

  const abrirAssistente = async () => {
    if (abrindo) {
      return
    }

    const janela = window.open('', '_blank')

    if (!janela) {
      falhar('Permita pop-ups deste site para abrir o assistente.')

      return
    }

    if (janela.document?.body) {
      janela.document.title = 'Assistente IA'
      janela.document.body.style.fontFamily = 'Roboto, sans-serif'
      janela.document.body.textContent = 'Abrindo o assistente…'
    }

    setAbrindo(true)

    try {
      const { data } = await axios.post(`${config.API_URL}/assistente/sessao`)
      const entradaUrl = data?.data?.entrada_url

      if (!entradaUrl) {
        throw new Error('Resposta sem entrada_url')
      }

      janela.opener = null
      janela.location.replace(entradaUrl)
    } catch (e) {
      janela.close()

      falhar(e?.response?.data?.message)
    } finally {
      setAbrindo(false)
    }
  }

  if (variant === 'header') {
    return (
      <Button
        className={classes.headerButton}
        onClick={abrirAssistente}
        disabled={abrindo}
        aria-label="Abrir o assistente IA em uma nova janela"
        startIcon={
          abrindo ? (
            <CircularProgress size={16} className={classes.progressHeader} />
          ) : (
            <Icon
              path={mdiCreation}
              size={0.75}
              className={classes.headerIcon}
            />
          )
        }
      >
        Assistente IA
      </Button>
    )
  }

  if (variant === 'icon') {
    return (
      <Tooltip title="Assistente IA">
        <span>
          <IconButton
            className={classes.iconButton}
            onClick={abrirAssistente}
            disabled={abrindo}
            aria-label="Abrir o assistente IA em uma nova janela"
          >
            {abrindo ? (
              <CircularProgress size={22} className={classes.progress} />
            ) : (
              <Icon path={mdiRobotOutline} size={1} />
            )}
          </IconButton>
        </span>
      </Tooltip>
    )
  }

  return (
    <Tooltip title="Assistente IA" placement="left">
      <span className={classes.wrapper}>
        <Fab
          className={classes.fab}
          onClick={abrirAssistente}
          disabled={abrindo}
          aria-label="Abrir o assistente IA em uma nova janela"
        >
          {abrindo ? (
            <CircularProgress size={24} className={classes.progress} />
          ) : (
            <Icon path={mdiRobotOutline} size={1.2} />
          )}
        </Fab>
      </span>
    </Tooltip>
  )
}

export default AssistenteIaFab
